import { PATH_DASHBOARD } from '../routes/paths';
import i18n from '../locales/i18n';

export const ACCOUNT_MENU_OPTIONS = [
  {
    label: i18n.t('home'),
    linkTo: '/',
  },
  {
    label: i18n.t('admin.profile.title'),
    linkTo: PATH_DASHBOARD.admin.profile,
  },
  {
    label: i18n.t('admin.settings.title'),
    linkTo: PATH_DASHBOARD.admin.settings,
  },
];
